import { useNavigate } from 'react-router-dom';
import XCircleFillIcon from '../../../assets/icons/XCircleFill';
import { useWhatsAppLogoutMutation } from '../api/chatApi';

const Logout = ({ session, onClose }) => {
  const { user_id, phone_number, push_name } = session || {};
  const [whatsAppLogoutApi] = useWhatsAppLogoutMutation();
  const navigate = useNavigate();

  const handleLogout = async() => {
    try {
      const response = await whatsAppLogoutApi({ id: user_id }).unwrap();
      if (response.success) {
        navigate('/employee');
      }
    } catch (error) {
      console.error('Logout error:', error);
    }
  }
  return (
    <div className='overlay' onClick={onClose}>
      <div className='content_layout' onClick={(e) => e.stopPropagation()}>
        <div className='content_header'>
          <h2>Logout</h2>
          <button className='close-btn' onClick={onClose}><XCircleFillIcon size={24} /></button>
        </div>

        <div className="content_body">
          <p>Are you sure want to logout <strong>{phone_number} - {push_name}</strong> employee?</p>
          <div className='layout_footer'>
            <button onClick={handleLogout} className='save-btn' >Logout</button>
            <button onClick={onClose} className='cancel-btn'>Cancel</button>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Logout
